import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';

import { EMPTY, of } from 'rxjs';

import { BaseFormComponent, FormManagerService } from '@sim/form';

import { Restoration, RestorationMeta } from '@atmi/core/models';
import { formatDateStrToIT, getFormatDate, getValidDateFromIT } from '@atmi/core/utils';
import { map } from 'rxjs/operators';

export interface RestorationData {
  restoration?: Restoration;
}

// extends BaseFormComponent<Restoration>
@Component({
  selector: 'app-restoration-dialog',
  styleUrls: ['./restoration-dialog.component.scss'],
  templateUrl: './restoration-dialog.component.html',
})
export class RestorationDialogComponent extends BaseFormComponent<Restoration> {

  readonly title = this.data.restoration
    ? this.translate.instant('Modifica restauro')
    : this.translate.instant('Aggiungi restauro');

  readonly mainActionLabel = this.data.restoration
    ? this.translate.instant('Salva')
    : this.translate.instant('Crea');

  constructor(
    private readonly dialogRef: MatDialogRef<RestorationDialogComponent>,
    protected readonly formManager: FormManagerService,
    protected readonly translate: TranslateService,
    protected readonly snackBarService: MatSnackBar,
    protected readonly router: Router,
    protected readonly route: ActivatedRoute,
    protected readonly spinner: NgxSpinnerService,
    protected readonly cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public readonly data: RestorationData,
  ) {
    super(
      snackBarService,
      translate,
      route,
      formManager,
      spinner,
      cd,
      RestorationMeta,
      () => of(data.restoration).pipe(map((r) => {
        return r
          ? {
            ...r,
            dataFine: r.dataFine && formatDateStrToIT(r.dataFine),
            dataInizio: r.dataInizio && formatDateStrToIT(r.dataInizio),
          }
          : undefined;
      })),
    );
  }

  addConcrete() {
    return EMPTY;
  }

  removeConcrete() {
    return EMPTY;
  }

  editConcrete() {
    return EMPTY;
  }

  resetFormConcrete() {
    return this.entityForm.reset();
  }

  completeHandler() {
    if (this.entityForm.valid) {
      const value = this.entityForm.value;
      const restoration: Restoration = {
        ...value,
        dataFine: value.dataFine ? getFormatDate(getValidDateFromIT(value.dataFine)) : null,
        dataInizio: value.dataInizio ? getFormatDate(getValidDateFromIT(value.dataInizio)) : null,
      };
      this.dialogRef.close(restoration);
    } else {
      this.entityForm.markAllAsTouched();
    }
  }
}
